const ArrowSelectDownMobile = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M6.66675 8.33333L9.41083 11.0774C9.73626 11.4028 10.2639 11.4028 10.5893 11.0774L13.3334 8.33333"
      stroke="#A1A1AA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ArrowSelectDownMobile
